import '@/styles/dmq-product-image-swiper.scss';
import Swiper from '@/swiper';

export default class DmqProductImageSwiper extends Swiper {
  constructor() {
    super('.dmq-product-image-swiper-container', {
      preloadImages: false,
      lazy: {
        elementClass: 'dmq-product-image-swiper-lazy',
        loadingClass: 'dmq-product-image-swiper-lazy-loading',
        loadedClass: 'dmq-product-image-swiper-lazy-loaded',
        preloaderClass: 'dmq-product-image-swiper-lazy-preloader',
      },
      containerModifierClass: 'dmq-product-image-swiper-container-',
      slideClass: 'dmq-product-image-swiper-slide',
      slideActiveClass: 'dmq-product-image-swiper-slide-active',
      slideDuplicateActiveClass: 'dmq-product-image-swiper-slide-duplicate-active',
      slideVisibleClass: 'dmq-product-image-swiper-slide-visible',
      slideDuplicateClass: 'dmq-product-image-swiper-slide-duplicate',
      slideNextClass: 'dmq-product-image-swiper-slide-next',
      slideDuplicateNextClass: 'dmq-product-image-swiper-slide-duplicate-next',
      slidePrevClass: 'dmq-product-image-swiper-slide-prev',
      slideDuplicatePrevClass: 'dmq-product-image-swiper-slide-duplicate-prev',
      wrapperClass: 'dmq-product-image-swiper-wrapper',
    });
  }
}
